export default {
    light: {
        // primary: '#1976D2',
        primary: '#3f51b5',
        secondary: '#424242',
        // accent: '#82B1FF',
        accent: '#E8EAF6',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        one: '#122034',
        two: '#8cc63f',
        tree: '#eeeeee',
        four: '#e2e2e2',
        five: '#fafafa',
        six: '#e5ddd5',
        seven: '#999999',
        eight: '#cccccc',
        nine: '#fafafa',
        ten: '#122034',
        eleven: '#0b4f6c',
        twelve: '#0b4f6c',
        thirteen: '#05172F', //cor padrao para o navbar e footerbar
        fourteen: '#eeeeee',
    },
    dark: {
        primary: '#2196F3',
        secondary: '#424242',
        // accent: '#FF4081',
        accent: '#444',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
        one: '#063970',
        two: '#8cc63f',
        tree: '#272727',
        four: '#272727',
        five: '#fafafa',
        six: '#272727',
        seven: '#999999',
        eight: '#272727',
        nine: '#272727',
        ten: '#272727',
        eleven: '#272727',
        twelve: '#fafafa',
        thirteen: '#05172F', //cor padrao para o navbar e footerbar
        fourteen: '#999999',
    },
};